export default "__VITE_ASSET__CsACpFnv__"